import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Box } from '@mui/material';
import { useAuth } from '../../contexts/AuthContext';
import AdminLayout from './AdminLayout';
import DashboardHome from './DashboardHome';
import UserManagement from './UserManagement';
import VendorManagement from './VendorManagement';
import VendorApproval from './VendorApproval';
import OfferManagement from './OfferManagement';
import Analytics from './Analytics';
import Settings from './Settings';

const AdminDashboard: React.FC = () => {
  const { user, isLoading } = useAuth();

  if (isLoading) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '100vh',
        }}
      >
        Loading...
      </Box>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return (
    <AdminLayout>
      <Routes>
        <Route path="/" element={<DashboardHome />} />
        <Route path="/users" element={<UserManagement />} />
        <Route path="/vendors" element={<VendorManagement />} />
        <Route path="/vendor-approval" element={<VendorApproval />} />
        <Route path="/offers" element={<OfferManagement />} />
        <Route path="/analytics" element={<Analytics />} />
        <Route path="/settings" element={<Settings />} />
      </Routes>
    </AdminLayout>
  );
};

export default AdminDashboard;

